export const SPACELIFT_LOGINS_COOKIE = "spacelift_logins";
